/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvTruncateSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvTruncateComponent = templateOnlyComponent<BvTruncateSignature>();

export default BvTruncateComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvTruncate: typeof BvTruncateComponent;
    'bv-truncate': typeof BvTruncateComponent;
  }
}
